import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import { ORG_TITLE_URL } from "../../../Constants/Constants";
import AxiosInstance from "../../../services/AxiosInstance";
import AppTableView from "../../AppTableView";
import OrgTitleDialog from "./OrgTitleDialog";

function OrgTitle() {


  useEffect(() => {
    getOrgTitles();
  }, []);

  const [data, setData] = useState([]);

  const getOrgTitles = () => {
    // TODO: server side pagination isn't implemented in server yet, so this will be currently client side pagination
    AxiosInstance.get(ORG_TITLE_URL).then((response) => setData(response.data.data));
  };

  return (
    <Container fluid style={{ display: "flex", flexDirection: "column" }}>
      <Box>
        <OrgTitleDialog
          editOrgTitleId={""}
          selectedOrgTitleId={""}
          orgTitleName={""}
          callOrgTitles={getOrgTitles}
          isEdit={false}
        />
      </Box>

      <AppTableView
        rows={data}
        cols={[
          {
            field: "name",
            headerName: "Title",
            flex: 1,
            renderCell: (params) => (
              <OrgTitleDialog
                editOrgTitleId={params.row.id}
                selectedOrgTitleId={params.row.id}
                orgTitleName={params.row.name}
                callOrgTitles={getOrgTitles}
                isEdit={true}
              />
            ),
          },
          {
            field: "active",
            headerName: "Active",
            flex: 1,
            renderCell: (params) => (params.value ? "Yes" : "No"),
          },
        ]}
        initialPageSize={15}
      />
    </Container>
  );
}
//https://mui.com/material-ui/react-table/#custom-pagination-actions
export default OrgTitle;
